import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
// import AllServiceProvidersTable from "./AllServiceProvidersTable";
import AllServiceProvidersNewList from "./AllServiceProvidersNewList";

function AllServiceProviders() {
  const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">All Service Providers</h1>
            <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={() => navigate("/ServiceTypePage")}
            >
              Add Service Type
            </Button>
            <Button
              className="primaryBtn"
              onClick={() => navigate("/AddServiceProvider")}
            >
              Add Service Provider
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {/* <AllServiceProvidersTable /> */}
              <AllServiceProvidersNewList />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AllServiceProviders;
